import { useContext, useState } from "react";
import {
  FormControl,
  TextField,
  Grid,
  IconButton,
  Typography,
  Box,
} from "@mui/material";
import { Filters } from "../../models/Filters";
import { ArrowDown, ArrowUp } from "@phosphor-icons/react";
import { LanguageContext } from "../../globals/LanguageContext";

type InvoiceDateFilterProps = {
  filters: Filters;
  onChange: (val: any) => void;
};

export function InvoiceDateFilter({
  filters,
  onChange,
}: InvoiceDateFilterProps) {
  const [inputValue, setInputValue] = useState("");
  const { dictionary } = useContext(LanguageContext);

  const handleInputChange = (val: string) => {
    setInputValue(val);
    onChange({ ...filters, invoiceDate: val });
  };

  const toggleSortDirection = () => {
    const current = filters.sortDirection?.direction;
    onChange({
      ...filters,
      sortDirection: {
        key: "invoiceDate",
        direction: current === "asc" ? "desc" : "asc",
      },
    });
  };

  return (
    <Grid container spacing={2} alignItems="center">
      <Grid item xs={12}>
        <Box display="flex" alignItems="center">
          <Typography variant="subtitle1" sx={{ mr: 1 }}>
            {dictionary.filters.invoiceDate}
          </Typography>
          <IconButton onClick={toggleSortDirection} size="small">
            {filters.sortDirection?.direction === "desc" ? (
              <ArrowDown fontSize="small" />
            ) : (
              <ArrowUp fontSize="small" />
            )}
          </IconButton>
        </Box>
      </Grid>

      <Grid item xs={12}>
        <FormControl fullWidth>
          <TextField
            label="Date / Month / Year"
            placeholder="e.g. 07, 10/07, 2025, 10/07/2025"
            value={inputValue}
            onChange={(e) => handleInputChange(e.target.value)}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
}
